export const INPUT_PROPS = {
    ID: 'dropDownSwitch',
};
